import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-afec81e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contractor-detail-card lg:!tw-w-[calc(50%_-_8px)] lg:!tw-max-w-full !tw-rounded-lg !tw-rounded-l-lg !tw-rounded-r-lg !tw-w-[340px] tw-max-w-full !tw-rounded-bl-lg !tw-rounded-br-lg md:!tw-w-full" }
const _hoisted_2 = { class: "tw-flex tw-items-start tw-justify-center tw-gap-4" }
const _hoisted_3 = {
  key: 0,
  class: "tw-flex tw-flex-col"
}
const _hoisted_4 = { class: "tw-flex tw-flex-col tw-items-start tw-w-full tw-gap-2" }
const _hoisted_5 = { class: "tw-flex tw-items-center tw-justify-start" }
const _hoisted_6 = { class: "tw-flex tw-items-center tw-justify-start tw-gap-2" }
const _hoisted_7 = { class: "!tw-text-[#1FB27A] !tw-font-bold" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "tw-w-full tw-flex tw-items-center tw-justify-end" }

import Text from "@/core/components/ui/general/Text.vue";
import Button from "@/core/components/ui/general/Button.vue";
import CheckGreen from "@/core/components/icons/CheckGreen.vue";
import ChipState from "@/core/components/common/ChipState.vue";
import RatingIcon from "@/core/components/icons/RatingIcon.vue";
import ProfileThumbnail from "@/core/uni-components/ProfileThumbnail.vue";
import Postcode from "@/core/uni-components/Chips/Postcode.vue";
import CountChip from "@/core/uni-components/Chips/CountChip.vue";

import $axios from "@/core/utils/axios-api-config";
import { onMounted, ref, computed } from "vue";
import { getImageApiUrl, getUserSubSkillList } from "@/core/utils/common";
import CustomBadge from "@/core/uni-components/CustomBadge.vue";
import { USER_STORE } from "@/store/modules/user";
import { useStore } from "vuex";
import { WORKSTATION } from "@/store/modules/workstation";

const __default__ = {
  name: "ContractorDetailCard",
};


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  subContractor: {
    type: Object,
  },
},
  setup(__props) {

const props = __props;
const imageUrl = ref(null);
const displayedSkills = computed(() => {
  return props.subContractor?.toUser?.user?.userSkills.slice(0, 2);
});

const remainingCount = computed(() => {
  return props.subContractor?.toUser?.user?.userSkills.length - 2;
});
const store = useStore();
const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);

const getAllSpecialism = computed(
  () => store.getters[`${USER_STORE}/getAllSpecialism`]
);

const getUserSkillList = (userSkill: any) => {
  return getUserSubSkillList(userSkill, getAllSpecialism.value);
};

onMounted(async () => {
  console.log("subcontractors", props.subContractor);
  try {
    if (!getAllSpecialism.value.length) {
      await store.dispatch(
        `${USER_STORE}/setAllSpecialismsCategory`,
        activeUserWorkstation.value.id
      );
    }
    const imageApiUrl = getImageApiUrl(
      props?.subContractor?.toContractorWorkstation?.profileImage,
      true
    );
    const encoded = await $axios.get(imageApiUrl);
    imageUrl.value = encoded.publicUrl;
  } catch (error) {
    console.log();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_fade_transition = _resolveComponent("v-fade-transition")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_expansion_panel, { class: "!tw-rounded-lg" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_expansion_panel_title, { class: "tw-p-4" }, {
          default: _withCtx(({ expanded }) => [
            _createElementVNode("section", _hoisted_2, [
              _createVNode(ProfileThumbnail, { src: imageUrl.value }, null, 8, ["src"]),
              _createVNode(_component_v_fade_transition, { "leave-absolute": "" }, {
                default: _withCtx(() => [
                  (!expanded)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(Text, {
                          whiteSpace: "nowrap",
                          variant: "h6"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.subContractor?.toContractorWorkstation?.name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(Text, {
                          variant: "span",
                          textColor: "rgba(12, 15, 74, 0.5)",
                          textWeigth: "600"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Limited Company")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_expansion_panel_text, { class: "tw-p-4" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(Text, {
                whiteSpace: "nowrap",
                variant: "h6"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.subContractor?.toContractorWorkstation?.name), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(Text, {
                  variant: "span",
                  textColor: "rgba(12, 15, 74, 0.5)",
                  textWeigth: "600"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Limited Company")
                  ]),
                  _: 1
                }),
                _createVNode(Postcode, {
                  value: __props.subContractor?.toUser?.postcode
                }, null, 8, ["value"]),
                _createVNode(ChipState, { hasCustomLabel: true }, {
                  prefix: _withCtx(() => [
                    _createVNode(RatingIcon)
                  ]),
                  "custom-label": _withCtx(() => [
                    _createVNode(Text, {
                      variant: "span",
                      textWeight: "400"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.subContractor?.ratings) + "/5 (" + _toDisplayString(__props.subContractor?.jobcompleted) + " Jobs) ", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(ChipState, {
                  hasCustomLabel: true,
                  bgColor: "rgba(12, 15, 74, 0.04)"
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(CheckGreen, { class: "tw-w-[16px] tw-h-[16px]" })
                  ]),
                  "custom-label": _withCtx(() => [
                    _createVNode(Text, {
                      variant: "span",
                      textWeight: "400"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(__props.subContractor?.toUser?.experience
                        ? `${__props.subContractor?.toUser?.experience} + Yrs `
                        : "N/A"), 1),
                        _createTextVNode(" Exp. ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (displayedSkills.value && displayedSkills.value.length)
                  ? (_openBlock(), _createBlock(CustomBadge, { key: 0 }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getUserSkillList(displayedSkills.value), (skill) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: "tw-text-[12px] tw-font-[700] tw-font-[#0C0F4A]",
                            key: skill.id
                          }, _toDisplayString(skill?.label), 1))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (remainingCount.value > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, " +" + _toDisplayString(remainingCount.value), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_component_v_divider, { class: "tw-mt-2 tw-mb-2" }),
            _createVNode(_component_v_card_actions, { class: "tw-border-t-2" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(Button, {
                    class: "!tw-w-auto !tw-px-0 !tw-py-0 tw-box-border !tw-text-[#4B4BFF] !tw-capitalize !tw-font-normal !tw-tracking-[0.15px]",
                    variant: "p",
                    label: "View Trade Passport"
                  }, {
                    postfix: _withCtx(() => [
                      _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})